/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = ./node_modules/webpack/buildin/amd-options.js
// module chunks = 0 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44